module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1004-68eb8b0e5c978828f77d043f571c8ba6.png";